import { sunny, umbrella, shuffle, snow, remove, reorderTwo, reorderThree } from "ionicons/icons";
export const modes = ["ΑΥΤΟΜΑΤΗ", "ΑΦΥΓΡΑΝΣΗ", "ΘΕΡΜΑΝΣΗ", "ΨΥΞΗ"];
export const modesIcons = [shuffle, umbrella, sunny, snow];
export const intensity = ["ΑΥΤΟΜΑΤΗ", "ΧΑΜΗΛΗ", "ΜΕΣΑΙΑ", "ΥΨΗΛΗ"];
export const intensityIcons = [shuffle, remove, reorderTwo, reorderThree];
